import "./App.css";
import { Route, Routes } from "react-router-dom";
import ProtectedRoutesOutlet from "./_routes/ProtectedRotuesOutlet";
import ProtectedRotues from "./_routes/ProtectedRoutes";
import { Toaster } from "react-hot-toast";
import PublicRoutes from "./_routes/PublicRoutes";
import PublicRoutesOutlet from "./_routes/PublicRotuesOutlet";
import Loader from "./_components/common/Loader";

function App() {
  return (
    <div className="container">
      <Loader />
      <Toaster
        position="top-right"
        containerClassName="hot-toaster-container"
      />
      <Routes>
        <Route element={<ProtectedRoutesOutlet />}>
          {ProtectedRotues?.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Route>
        <Route element={<PublicRoutesOutlet />}>
          {PublicRoutes?.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Route>
        <Route path="*" element={<p>404 Not Found!</p>} />
      </Routes>
    </div>
  );
}

export default App;
